import styled from 'styled-components';
import { ReactComponent as EmptyFolder } from 'Images/empty-folder.svg';
import { ReactComponent as PlannerIcon } from 'Images/tasks_icon.svg';

export const Wrapper = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: right;
  margin: 0px;
  box-sizing: border-box;
  height: 37px;
  margin-bottom: 9px;
`;
Wrapper.displayName = 'Wrapper';

export const Separator = styled.div`
  &::after {
    margin: auto 0px;
    width: 1px;
    content: ' ';
    background: transparent;
    border-right: 1px #B5BEC6;
    border-right-style: dashed;
    display: block; 
    height: 11px;
  }
`;
Separator.displayName = 'Separator';

export const Group = styled.div`
  display: flex;
  align-items: center;
`;
Group.displayName = 'Group';

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  padding-left: 8px;
  & > *:not(:last-child) {
      margin-right: 15px;
  }
`;
LeftGroup.displayName = 'LeftGroup';

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  & > * {
      margin-right: 15px;
  }
`;
RightGroup.displayName = 'RightGroup';

// Same icon the real Manual Grouping button uses -- so its EELockedFeature fallback
// (community, or an unlicensed professional user) stays visually identifiable instead of
// falling back to a generic lock, while still opening the upgrade-license modal on click.
export const ManualGroupingIcon = styled(EmptyFolder)`
  cursor: pointer;
  height: 14px;
  margin-left: 8px;
  path {
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
`;
ManualGroupingIcon.displayName = 'ManualGroupingIcon';

// Same icon the real Quick Planner button uses -- so its EELockedFeature fallback
// stays visually identifiable instead of falling back to a generic lock, while still
// opening the upgrade-license modal on click.
export const QuickPlannerIcon = styled(PlannerIcon)`
  cursor: pointer;
  min-width: 17px;
  margin-left: 8px;
  g {
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
  g > path {
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
`;
QuickPlannerIcon.displayName = 'QuickPlannerIcon';
